var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    viewBox: "0 0 11 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete_forever copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1339.000000, -311.000000)",
    fill: "#E6E6E6",
    id: "delete_forever-copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1339.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.785714286,13.3333333 C0.785714286,14.25 1.49285714,15 2.35714286,15 L8.64285714,15 C9.50714286,15 10.2142857,14.25 10.2142857,13.3333333 L10.2142857,3.33333333 L0.785714286,3.33333333 L0.785714286,13.3333333 Z M2.71857143,7.4 L3.82642857,6.225 L5.5,7.99166667 L7.16571429,6.225 L8.27357143,7.4 L6.60785714,9.16666667 L8.27357143,10.9333333 L7.16571429,12.1083333 L5.5,10.3416667 L3.83428571,12.1083333 L2.72642857,10.9333333 L4.39214286,9.16666667 L2.71857143,7.4 Z M8.25,0.833333333 L7.46428571,0 L3.53571429,0 L2.75,0.833333333 L0,0.833333333 L0,2.5 L11,2.5 L11,0.833333333 L8.25,0.833333333 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.732c0583e8f42d4f37614bcdbccaf565.svg";
export { ForwardRef as ReactComponent };